import { ApplicationRef } from '@angular/core';

/**
 * Utils function called while SSR bootstrap to identify possible bottlenecks.
 * @param bootstrapFn
 * @returns
 */
export function logSSRBootstrapPerformance(bootstrapFn: () => Promise<ApplicationRef>): Promise<ApplicationRef> {
  const startTime = performance.now();
  return bootstrapFn().then(appRef => {
    const bootstrapEndTime = performance.now();
    console.info(`[SSR] Bootstrap Application loaded in ${(bootstrapEndTime - startTime).toFixed(2)} ms`);

    let isStableLogged = false;
    appRef.injector.get(ApplicationRef).isStable.subscribe(isStable => {
      if (isStable && !isStableLogged) {
        isStableLogged = true;
        const stableEndTime = performance.now();
        console.info(`[SSR] Application is stable in ${(stableEndTime - startTime).toFixed(2)} ms`);
      }
    });

    return appRef;
  });
}

/**
 * Utils function called while Client bootstrap to identify possible bottlenecks.
 * @param bootstrapFn
 * @returns
 */
export function logClientBootstrapPerformance(bootstrapFn: () => Promise<ApplicationRef>): Promise<ApplicationRef> {
  const startTime = performance.now();
  return bootstrapFn()
    .then(appRef => {
      const endTime = performance.now();
      console.info(`[Client] Bootstrap loaded in ${(endTime - startTime).toFixed(2)} ms`);
      return appRef;
    })
    .catch(err => {
      console.error(`[Client] Bootstrap failed:`, err);
      throw err;
    });
}
